/**
 * Función que verifica la validez de un número de RUC
 *
 */
export const RucValidator = (value: string): boolean => {
  const iaux = new Array<number>();
  for (let iContA = 1; iContA <= 11; ++iContA) {
    iaux[iContA] = +value.substr(iContA - 1, 1);
  }
  iaux[1] = iaux[1] * 5;
  iaux[2] = iaux[2] * 4;
  iaux[3] = iaux[3] * 3;
  iaux[4] = iaux[4] * 2;
  iaux[5] = iaux[5] * 7;
  iaux[6] = iaux[6] * 6;
  iaux[7] = iaux[7] * 5;
  iaux[8] = iaux[8] * 4;
  iaux[9] = iaux[9] * 3;
  iaux[10] = iaux[10] * 2;
  let iA: number = 0;
  for (let iContB = 1; iContB <= 10; ++iContB) {
    iA = iA + iaux[iContB];
  }
  const iB: number = parseInt((iA / 11).toString());
  const iC: number = iA - iB * 11;
  const iD: number = 11 - iC;
  let invalid: boolean = true;
  if (iD === 10 && iaux[11] === 0) {
    invalid = false;
  } else if (iD === 11 && iaux[11] === 1) {
    invalid = false;
  } else if (iD === iaux[11]) {
    invalid = false;
  }
  if (invalid) return false;

  return false;
};
